import "./style.css";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
export default function ProductCard({ name, index }) {
  // eslint-disable-next-line no-unused-vars
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 700,
        md: 1080,
        lg: 1200,
      },
    },
  });

  return (
    <ThemeProvider theme={customTheme}>
      <div
        className="card"
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <a
          target="_blank"
          rel="noreferrer"
          className="cardMediaLink"
          style={{textDecoration:'none'}}
          href={`/nos-produits/${name}`}
        >
          <div
            className="card"
            style={{
              height: { lg: "300px", md: "300px", sm: "300px", xs: "240px" },
              width: { lg: "15vw", md: "28vw", sm: "28vw", xs: "160px" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={require(`../../Images/Produits/${name}.jpg`)}
              alt={name}
              className="cardMediaHome"
            />
            <span
              className="cardMediaText"
            >
              <Typography
                gutterBottom
                textTransform="uppercase"
                variant="h6"
                fontSize={{ lg: "12px", md: "11px", sm: "11px", xs: "9px" }}
                color="#000"
                display="flex"
                flexDirection="row"
                textAlign="center"
                fontFamily="Brown"
                fontWeight={700}
                letterSpacing="1px"
              >
                {name}{" "}
              
              </Typography>
            </span>
          </div>
        </a>
      </div>
    </ThemeProvider>
  );
}
